module.exports = function (json) {
    var options = {};

    function valueIterator(value) {
        var val = value.$text();
        if (/^(Yes|No)$/.test(val)) {
            val = (val == 'Yes');
        }
        options[value.$attr('name')] = val;
    }

    if (json.ipc) {
        json.$('ipc/figure/media').filter(function (media) {
            return media.$attr('id') == 1;
        })[0].$('value').forEach(valueIterator);
    } else if (json.SimulationInteractivity) {
        json.$('SimulationInteractivity/SimulationInformation/Options/Value').forEach(valueIterator);

        var SimulationInformation = json.SimulationInteractivity.SimulationInformation;
        options.PublisherVersion = SimulationInformation.$text('ExporterVersionNumber');
        options.SpecID = SimulationInformation.$text('SpecID');
        options.SpecVersion = SimulationInformation.$text('SpecVersion');
        options.SpecLang = SimulationInformation.$text('SpecLang');
        options.ModificationDate = SimulationInformation.$text('ModificationDate');
        options.DocumentFile = SimulationInformation.$text('DocumentFile');
    }

    return options;
};